import React from 'react';
import S from '../style/Dac7TabContent';
import Dac7Input from './Dac7Input';
import V from '../utils/validation';
import { SellerPrivateDac7 } from '../../../../../../typings/dac7';
import { useI18n } from '../../../../../i18n';
import Dac7ZipCodeField from './Dac7ZipCodeField';
import useDac7ArrayItems from '../hooks/useDac7ArrayItems';
import Dac7Dropdown from './Dac7Dropdown';
import countries from '../utils/countriesList';

type Addresses = SellerPrivateDac7['addresses'];

interface Props {
  addresses: Readonly<Addresses>;
}

const Dac7Addresses = ({ addresses: addressesInitial }: Props) => {
  const { items: addresses } = useDac7ArrayItems(addressesInitial);
  const i18n = useI18n();

  return (
    <>
      {addresses.map((address, i) => (
        <S.Dac7Fieldset
          className="dac7-addresses"
          key={`dac7_addresses_${address.feId}`}
          disabled={!!address.street}
        >
          <S.Dac7FormField>
            <Dac7Dropdown
              sourceItems={countries}
              initialSelectedIds={[address.country]}
              name={`dac7_addresses.${i}.country`}
              label={i18n('dlv_dac7_country')}
              placeholder={i18n('dlv_dac7_countryPlaceholder')}
              required
            />
          </S.Dac7FormField>
          <S.Dac7FormField>
            <Dac7Input
              name={`dac7_addresses.${i}.street`}
              label={i18n('dlv_dac7_street')}
              pattern={V.getMinCharsPattern(2)}
              required
              type="text"
              value={address.street || ''}
            />
          </S.Dac7FormField>
          <S.Dac7HouseNumberApartmentContainer>
            <S.Dac7FormField>
              <Dac7Input
                name={`dac7_addresses.${i}.houseNumber`}
                label={i18n('dlv_dac7_houseNumber')}
                pattern={V.getMinCharsPattern(1)}
                required
                type="text"
                value={address.houseNumber || ''}
              />
            </S.Dac7FormField>
            <S.Dac7FormField>
              <Dac7Input
                name={`dac7_addresses.${i}.apartmentNumber`}
                label={i18n('dlv_dac7_apartmentNumber')}
                type="text"
                value={address.apartmentNumber || ''}
              />
            </S.Dac7FormField>
          </S.Dac7HouseNumberApartmentContainer>
          <S.Dac7FormField>
            <Dac7Input
              name={`dac7_addresses.${i}.city`}
              label={i18n('dlv_dac7_city')}
              pattern={V.getMinCharsPattern(2)}
              required
              type="text"
              value={address.city || ''}
            />
          </S.Dac7FormField>
          <S.Dac7FormField>
            <Dac7ZipCodeField
              name={`dac7_addresses.${i}.zipCode`}
              label={i18n('dlv_dac7_zipCode')}
              required
              value={address.zipCode || ''}
            />
          </S.Dac7FormField>
        </S.Dac7Fieldset>
      ))}
      <S.StyledRequiredFieldsText>
        {i18n(`dlv_dac7_required_fields_description`)}
      </S.StyledRequiredFieldsText>
    </>
  );
};

export default Dac7Addresses;
